import api from '@/api'

const state = {
}

const mutations = {
}
const actions = {
  // 检查供应商状态
  checkSupplierStatus () {
    return new Promise((resolve, reject) => {
      api.checkSupplierStatus().then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualification/checkSupplierStatus',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualification/checkSupplierStatus', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取营业执照等 基础资质
  getSupQualificationInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getSupQualificationInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualification/getSupQualificationInfo',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualification/getSupQualificationInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取资格证列表等 拓展资质
  getSupQualificationExtInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getSupQualificationExtInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualification/getSupQualificationExtInfo',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualification/getSupQualificationExtInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 修改基础资质
  modifySupplierQualificationInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.modifySupplierQualificationInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualification/modifySupplierQualificationInfo',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualification/modifySupplierQualificationInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 修改 拓展资质
  modifySupplierQualificationExtInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.modifySupplierQualificationExtInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualification/modifySupplierQualificationExtInfo',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualification/modifySupplierQualificationExtInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取资格操作日志
  getSupQualificationChangeHistoryInfo () {
    return new Promise((resolve, reject) => {
      api.getSupQualificationChangeHistoryInfo().then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualification/getSupQualificationChangeHistoryInfo',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualification/getSupQualificationChangeHistoryInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取证件操作日志
  getSupQualificationExtChangeHistoryInfo () {
    return new Promise((resolve, reject) => {
      api.getSupQualificationExtChangeHistoryInfo().then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualification/getSupQualificationExtChangeHistoryInfo',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualification/getSupQualificationExtChangeHistoryInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取供应商商品资质列表
  getSupplierProductList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getSupplierProductList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualificationNew/getSupplierProductList',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualificationNew/getSupplierProductList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取供应商商品资质列表
  getSupplierProductQualification ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getSupplierProductQualification(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualificationNew/getSupplierProductQualification',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualificationNew/getSupplierProductQualification', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 修改产品库资质接口
  modifySupplierProductQualification ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.modifySupplierProductQualification(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualificationNew/modifySupplierProductQualification',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualificationNew/modifySupplierProductQualification', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 修改产品库资质接口
  getSupplierDocumentChangeFlow ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getSupplierDocumentChangeFlow(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualificationNew/getSupplierDocumentChangeFlow',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualificationNew/getSupplierDocumentChangeFlow', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 查看产品库资质审核日志
  getSupplierDocumentChangeList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getSupplierDocumentChangeList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/srmSupQualificationNew/getSupplierDocumentChangeList',
            error: resData.error
          })
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupQualificationNew/getSupplierDocumentChangeList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取库主ID以及sign
  getCargoSign ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getCargoSign(data).then(res => {
        let resData = res.data || {}
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          reject({
            from: '/sweb/supplierCargo/getCargoSign',
            error: resData.error.error || { msg: '网络异常，请稍后再试' }
          })
        }
      }).catch(e => {
        reject({from: '/sweb/supplierCargo/getCargoSign', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/certManage.js